/**
 * Pagination request options
 */
export interface PaginationOptions {
  page?: number;      // 페이지 번호 (1부터 시작)
  limit?: number;     // 페이지당 항목 수
  offset?: number;    // 직접 offset 지정 (page와 함께 사용 불가)
  orderBy?: string;   // 정렬 필드
  order?: 'asc' | 'desc';  // 정렬 방향
  cursor?: string;    // 커서 기반 페이징용 (향후 구현)
}

/**
 * Pagination metadata
 */
export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  nextCursor?: string;
  previousCursor?: string;
}

/**
 * Paginated response wrapper
 */
export interface PaginatedResponse<T> {
  data: T[];
  pagination: PaginationMeta;
}

/**
 * Helper to check if pagination options are provided
 */
export function isPaginationRequested(options: any): options is PaginationOptions {
  return options && (
    typeof options.page === 'number' || 
    typeof options.limit === 'number' ||
    typeof options.cursor === 'string'
  );
}

/**
 * Convert page/limit to offset
 */
export function getOffsetFromPage(page: number = 1, limit: number = 20): number {
  return (page - 1) * limit;
}

/**
 * Calculate pagination metadata
 */
export function calculatePaginationMeta(
  total: number,
  page: number = 1,
  limit: number = 20
): PaginationMeta {
  const totalPages = Math.ceil(total / limit);
  
  return {
    page,
    limit,
    total,
    totalPages,
    hasNextPage: page < totalPages,
    hasPreviousPage: page > 1,
  };
}

/**
 * Default pagination values
 */
export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT = 20;
export const MAX_LIMIT = 100;